import { GridColumn, GridRow } from 'app/layouts/grid';
import { Button } from 'app/shared/button';
import { BasicInfoSection } from 'app/shared/info-section/basic';
import { DetailItem } from 'app/shared/info-section/item';
import { SimpleInput } from 'app/shared/input';
import { useMessagingPreferenceService } from 'hooks/messaging/preference';
import React, { useEffect, useState } from 'react';

export const SMSWebhookConfiguration = () => {
  const { fetchPreferences, setPreference } = useMessagingPreferenceService();

  const [is_saving, setIsSaving] = useState(false);
  const [sms_config, setSMSConfig] = useState({});
  const [webhook_url, setWebhookURL] = useState('');

  useEffect(() => {
    fetchPreferences().then(({ preferences: [preference] }) => {
      if (!preference || !preference.sms) {
        return;
      }

      setSMSConfig(preference.sms || {});
      setWebhookURL(preference.sms?.webhook_url || '');
    });
  }, []);

  const submit = async () => {
    const data = {
      sms: { ...sms_config, webhook_url }
    };

    setIsSaving(true);
    await setPreference({ data });
    setIsSaving(false);
  };

  return (
    <BasicInfoSection title="SMS Configuration">
      <DetailItem title="Webhook">
        <SimpleInput value={webhook_url} onInput={setWebhookURL} placeholder="Enter webhook URL" />
      </DetailItem>
      <GridRow num_of_columns={3}>
        <GridColumn span={2} />
        <GridColumn>
          <Button text="Save changes" onClick={submit} disabled={is_saving} loading={is_saving} />
        </GridColumn>
      </GridRow>
    </BasicInfoSection>
  );
};
